'use client';

import { type Dispatch, type ReactNode, type SetStateAction } from 'react';

import { Tabs as MantineTabs, type TabsProps } from '@mantine/core';

interface ITabs extends Omit<TabsProps, 'value' | 'onTabChange'> {
  activeTab?: string | null;
  setActiveTab?: Dispatch<SetStateAction<string | null>>;
}

export const Tabs = ({ variant, orientation, activeTab, setActiveTab, children, defaultValue }: ITabs) => (
  <MantineTabs
    variant={variant}
    orientation={orientation}
    className="mt-8 flex w-full min-w-full flex-col text-left md:mt-2 md:items-start md:justify-start lg:mt-0"
    styles={{ panel: { width: '100%' } }}
    value={activeTab}
    onTabChange={setActiveTab}
    defaultValue={defaultValue}
  >
    {children}
  </MantineTabs>
);

const TabsList = ({ className, children }: { className?: string; children: ReactNode }) => (
  <MantineTabs.List className={className}>{children}</MantineTabs.List>
);

const TabsTab = ({ value, children }: { value: string; children: ReactNode }) => (
  <MantineTabs.Tab value={value}>{children}</MantineTabs.Tab>
);

const TabsPanel = ({ value, pt, children }: { value: string; pt?: string; children: ReactNode }) => (
  <MantineTabs.Panel value={value} pt={pt}>
    {children}
  </MantineTabs.Panel>
);

export { TabsList, TabsPanel, TabsTab };

Tabs.displayName = 'Tabs';
